import { mockFetch } from 'utils/fetchMock';
import { getUserMeApiUrl } from 'utils/links';
import { PlansIds, SUBSCRIPTION_PERIOD } from 'constants/config';

const MOCK_USER = process.env.NODE_ENV === 'development';

const mockedUser = {
  id: 111,
  name: 'Test User',
  image: '',
  streamer: true,
  created_at: new Date().toISOString(),
  v2_access: true,
  subscription: {
    name: 'Test Plan',
    plan: PlansIds.FREE,
    days_left: 594,
    renewable: false,
    interval: SUBSCRIPTION_PERIOD.EMPTY,
  },
  studio: { id: 1 },
  features: {
    fastspring: 1,
  },
  // appsumo: true,
};

export const getUser = () => {
  if (MOCK_USER) {
    return mockFetch(JSON.stringify(mockedUser), 1000);
  } else {
    return fetch(getUserMeApiUrl(), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      credentials: 'include',
    });
  }
};
